import React from 'react';
import { Modal, } from 'antd';
import { useQuery } from 'react-query';
import Check from './Check';

import { getTaskCheckEntity, TaskCheckEntityResponse } from 'services/workflow';
import Button from 'components/Button';
import { noop } from 'lodash';
import DF from 'DisplayFramework';


export type CheckModalProps = {
  entityId: number;
  entity: string;
  onCancel: () => void;
  checkid: number;
  taskid: number;
  visible: boolean;
  title: string;
  onSuccess?: () => void;
  checksList?: TaskCheckEntityResponse[];
};

const CheckModal = ({
  entityId,
  entity,
  onCancel,
  checkid,
  taskid,
  visible,
  title,
  checksList,
  onSuccess = noop,
}: CheckModalProps) => {
  const params = {
    entity: entity,
    entityid: entityId,
    taskid: taskid,
  };

  const { data: checks, refetch: refetchChecks } = useQuery(
    ['getTaskCheckEntity', params],
    () => getTaskCheckEntity(params).then((res) => res.list || []),
    { enabled: visible }
  );

  return (
    <DF.Provider pagcode="checkmodal">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1400}
        title={title}
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
       
      >
        <Check
          checks={
            checksList ? (checksList.length > 0 ? checksList : checks) : checks
          }
          onSuccess={() => refetchChecks()}
        />
      </Modal>
    </DF.Provider>
  );
};

export default CheckModal;
